import { useMemo } from "react";
import Copy from "../../components/modals/Copy";
import { useVisible } from "../../../../../utils/hooks/useVisible";

export const useCopyModal = () => {
    const { visible, open, close, selected } = useVisible();

    const modal = useMemo(() => {
        return (
            <Copy 
                close={close}
                visible={visible}
                values={selected}
            />
        );
    }, [close, visible, selected]);

    return { open, modal };
}